import React, { FC, useState, useEffect } from "react";
import { Box, Modal as MuiModal, TextField, Typography } from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDButton from "mdComponents/MDButton";
import MDTypography from "mdComponents/MDTypography";
import { LocationHostUser } from "../models/locationHostUserModel"; 
import { formatDate } from "../Utils";

interface LocationHostAdminDetailsModalProps {
  visible: boolean;
  selectedItem?: LocationHostUser;
  editMode: boolean;
  onSaveChanges: (hostUser: LocationHostUser) => void;
  onDelete: (id: number) => void;
  onDone: () => void;
}

const LocationHostAdminDetailsModal: FC<LocationHostAdminDetailsModalProps> = ({
  visible,
  selectedItem,
  editMode,
  onSaveChanges,
  onDelete,
  onDone,
}) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (visible && editMode && selectedItem) {
      setEmail(selectedItem.email);
    }
    if (visible && !editMode) {
      setEmail("");
    }
  }, [visible, editMode, selectedItem]);

  const handleSave = () => {
    if (!selectedItem && editMode) return;

    const updated: LocationHostUser = {
      ...(selectedItem ?? ({} as LocationHostUser)),
      email: email,
    };

    onSaveChanges(updated);
  };

  const handleDelete = () => {
    if (selectedItem) onDelete(selectedItem.id);
  };

  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 450,
          maxWidth: "90%",
        }}
      >
        <MDTypography variant="h5" fontWeight="medium">
          {editMode ? "Edit Host Admin" : "Add Host Admin"}
        </MDTypography>
          <MDTypography
            color="text"
            fontWeight="light" mb={2}
            sx={{
              fontSize: "0.85rem",
              lineHeight: 1.2,
              display: "block",
            }}
          >
            Pappa Squat user accounts registered with this email address will have access to all settings for this location.
          </MDTypography>

        <MDBox display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {editMode && selectedItem && (
            <MDTypography variant="body2" color="text">
              Admin Since: {formatDate(selectedItem.created_at, true)}
            </MDTypography>
          )}
        </MDBox>

        <MDBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
          <MDButton variant="outlined" color="secondary" onClick={onDone}>
            Cancel
          </MDButton>
          <MDButton color="info" onClick={handleSave}>
            {editMode ? "Update" : "Save"}
          </MDButton>
        </MDBox>
      </Box>
    </MuiModal>
  );
};

export default LocationHostAdminDetailsModal;
